import {
  SetUserFeatureCreditsRequest,
  SuccessStatus,
} from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const setUserFeatureCredits = (
  req: Partial<SetUserFeatureCreditsRequest>
): Promise<SuccessStatus> =>
  request({
    url: '/service/userv2service/SetUserFeatureCredits',
    body: req,
  }).then((r) => r.body);
